import { z } from "zod";

/** Scalar limits and included amounts for an organization (merged from plan + Stripe + ops). */
export const organizationEntitlementsSchema = z
  .object({
    plan_key: z.string().optional(),
    included_production_controlled_actions_per_month: z.number().int().nonnegative(),
    included_sandbox_evaluations_per_month: z.number().int().nonnegative(),
    included_members: z.number().int().nonnegative(),
    max_members: z.number().int().positive(),
    max_extra_paid_members: z.number().int().nonnegative(),
    included_workspaces: z.number().int().nonnegative(),
    max_workspaces: z.number().int().positive(),
    max_extra_paid_workspaces: z.number().int().nonnegative(),
    allow_extra_workspaces: z.boolean(),
    max_action_types: z.number().int().positive(),
    max_active_production_policies: z.number().int().positive(),
    audit_retention_days: z.number().int().positive(),
    allow_paid_production_overage: z.boolean(),
    extra_member_unit_usd: z.number().nonnegative().optional(),
    extra_workspace_unit_usd: z.number().nonnegative().optional(),
    production_overage_unit_usd: z.number().nonnegative().optional(),
    feature_sdk_api: z.boolean(),
    feature_signed_production_permits: z.boolean(),
    feature_sandbox_bot_modes: z.boolean(),
    feature_manual_approval: z.boolean(),
    feature_limited_manual_approval: z.boolean(),
    feature_basic_audit: z.boolean(),
    feature_standard_webhooks: z.boolean(),
    feature_policy_simulation: z.boolean(),
    feature_approval_groups: z.boolean(),
    feature_escalation_rules: z.boolean(),
    feature_audit_export: z.boolean(),
    feature_sso: z.boolean(),
    feature_scim: z.boolean(),
    feature_advanced_rbac: z.boolean(),
    feature_audit_streaming: z.boolean(),
    feature_sla: z.boolean(),
    feature_invoice_billing: z.boolean(),
    feature_connector_hubspot: z.boolean().default(false),
    feature_connector_intercom: z.boolean().default(false),
    feature_connector_zendesk: z.boolean().default(false)
  })
  .passthrough();

export type OrganizationEntitlements = z.infer<typeof organizationEntitlementsSchema>;

export const organizationEntitlementOverridesSchema = z.record(z.unknown());
export type OrganizationEntitlementOverrides = z.infer<
  typeof organizationEntitlementOverridesSchema
>;
